import BaseEntity from "../BaseEntity";

export default class SeedLabel extends BaseEntity {
  SeedPackLabel = "";
  Treatment = false;
}
